export default function(message) {
  console.log(message)
}
